// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

const StyleReceiver = styled.div`
  pointer-events: none;
`;

const Wrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0.5em 0.65em;
  border-radius: 100em;
  background-color: var(--swipe-background-color, #51515166);

  font-size: 95%;
`;

const PaginationChip = styled.div`
  width: 0.6em;
  height: 0.6em;
  background-color: var(--swipe-dot-background-color, #ffffff4d);
  border-radius: 50%;
  border: 1px solid var(--swipe-dot-border-color, transparent);
  transition: none 200ms ease-in-out;
  transition-property: background-color;

  &:not(:last-child) {
    margin-right: 0.6em;
  }

  ${({ $isCurrent }) => css`
    ${$isCurrent
      ? css`
          background-color: var(--swipe-dot-active-background-color, white);
        `
      : undefined}
  `}
`;

type SwipePaginationProps = {
  className?: string;
  maxViews: number;
  index: number;
};

const SwipePagination = ({ className = '', maxViews, index }: SwipePaginationProps) => {
  const shouldRender = useMemo(() => typeof maxViews === 'number' && typeof index === 'number', [maxViews, index]);

  return shouldRender ? (
    <StyleReceiver className={className}>
      <Wrapper>
        {[...new Array(maxViews).keys()].map((i) => (
          <PaginationChip key={`swipe-pagination-chip-${i}`} $isCurrent={i === index} />
        ))}
      </Wrapper>
    </StyleReceiver>
  ) : null;
};

export default SwipePagination;
